const formatDate = (date) => {
  return new Date(date).toGMTString();
};

export default formatDate;
